import { useTranslation } from 'react-i18next';

const TIME_SLOTS = [
  '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
  '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
];

interface TimeSelectorProps {
  selected: string | null;
  onChange: (time: string) => void;
}

export default function TimeSelector({ selected, onChange }: TimeSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 rounded-2xl border border-background-200/70 p-5 md:p-6">
      <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-4">
        {t('booking.time_label')}
      </h3>

      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {TIME_SLOTS.map((time) => {
          const isSelected = selected === time;
          return (
            <button
              key={time}
              onClick={() => onChange(time)}
              className={`min-h-[40px] py-2.5 px-3 rounded-lg text-xs font-label font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                isSelected
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 border border-background-200/70'
              }`}
            >
              {time}
            </button>
          );
        })}
      </div>

      {selected && (
        <p className="mt-3 text-xs text-foreground-400 font-body">
          {t('booking.time_selected')} <span className="text-primary-600 font-semibold">{selected} {t('booking.time_unit')}</span>
        </p>
      )}
    </div>
  );
}